import { createSlice } from '@reduxjs/toolkit'
import { LicenseUpdatesSchema } from '../types/LicenseUpdate'
import { fetchLicenseUpdates } from '../services/fetchLicenseUpdates'


const initialState: LicenseUpdatesSchema = {
	limit: 10,
	error: '',
	isLoading: false,

	paginatedLicenseUpdates: {
		currentPage: 1,
		items: []
	},
	filter: {},
	queryFilter: {},
	sort: {}
}

const licenseUpdatesSlice = createSlice({
	name: 'licenseUpdates',
	initialState,
	reducers: {
		setPage: (state, action) => {
			state.paginatedLicenseUpdates.currentPage = action.payload
		},
		resetPage: (state) => {
			state.paginatedLicenseUpdates.currentPage = 1
		},
		setLimit: (state, action) => {
			state.limit = action.payload
		},
		setSort: (state, action) => {
			state.sort.sort = action.payload
		},
		setDirection: (state, action) => {
			state.sort.direction = action.payload
		},
		setUpdateTimeFrom: (state, action) => {
			state.filter.updateTimeFrom = action.payload
		},
		setUpdateTimeTo: (state, action) => {
			state.filter.updateTimeTo = action.payload
		},
		setQueryFilter: (state) => {
			state.queryFilter = { ...state.filter }
		},
		removeFilter: (state, action) => {
			const filterName: keyof typeof state.queryFilter = action.payload
			delete state.filter[filterName]
			delete state.queryFilter[filterName]
		},
		resetFilter: (state) => {
			state.filter = {}
			state.queryFilter = {}
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchLicenseUpdates.pending, (state) => {
				state.isLoading = true
				state.error = ''
			})
			.addCase(fetchLicenseUpdates.fulfilled, (state, action) => {
				const licenseUpdates = action.payload

				state.paginatedLicenseUpdates.items = licenseUpdates
				state.paginatedLicenseUpdates.totalCount = licenseUpdates?.length ?? 0
				state.isLoading = false
			})
			.addCase(fetchLicenseUpdates.rejected, (state, action) => {
				state.isLoading = false
				state.error = action.payload
			})
	}
})

export const { actions: licenseUpdatesActions } = licenseUpdatesSlice
export const { reducer: licenseUpdatesReducer } = licenseUpdatesSlice
